@import "@/scss/use-bootstrap-mixins.scss";

.card_wrapper {
  @include media-breakpoint-up(lg) {
    display: flex;
    justify-content: space-between;
    align-items: start;
    position: relative;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.upsell_copy {
  // z-index: -999;
  position: relative;
  text-align: center;

  .or {
    margin-top: 12px;
    font-weight: 500 !important;
  }

  .price_difference {
    margin-bottom: 12px;
  }

  .or,
  .price_difference {
    display: block;
    text-align: center;
  }

  @include media-breakpoint-up(lg) {
    height: 100%;
    max-width: 100px;
    width: 100px;

    .or {
      margin: 0 !important;
      font-size: 38px !important;
    }

    .price_difference {
      display: none;
    }
  }
}

.desktop {
  display: none !important;
  @include media-breakpoint-up(lg) {
    display: block !important;
    margin: 15% auto;
  }
}

.mobile {
  display: block !important;
  @include media-breakpoint-up(lg) {
    display: none !important;
  }
}
